import './ValidateEmail.css';
import { Button } from '../../ui';
import { useValidateEmail } from '../../../hooks';

export function ValidateEmail(props: {
   email: string;
   onSubmit: (verificationCode: string) => void;
   onCancel: () => void;
   isLoading: boolean;
   onResend: () => void;
   hideText?: boolean;
}) {
   const { onSubmit, onCancel, isLoading, email, onResend, hideText } = props;
   const { code, setCode, handlePaste, updateFocus, inputRef, setFocus } = useValidateEmail();
   const submit = (e: any, data: { code: string }) => {
      e.preventDefault();
      onSubmit(data.code.trim());
   };

   return (
      <form
         className="email-validate flex flex-col gap-3 w-100"
         onSubmit={(e) => submit(e, { code: code.join('') })}>
         <div className="flex flex-col items-center gap-2">
            <div className="flex gap justify-center code-inputs">
               {code.map((char, index: number) => (
                  <input
                     key={index}
                     ref={(el) => (inputRef.current[index] = el)}
                     className="code-input"
                     value={char}
                     inputMode="numeric"
                     pattern="[0-9]*"
                     maxLength={1}
                     onChange={(e) => {
                        if (!/^[0-9]*$/.test(e.target.value)) return;

                        const value = e.target.value.slice(-1); // Ensure single character
                        const newCode = [...code];
                        newCode[index] = value;
                        setCode(newCode);

                        if (value) {
                           updateFocus(index, 'next');
                        }
                     }}
                     onPaste={(e) => {
                        if (index === 0) handlePaste(e);
                     }}
                     onKeyDown={(e) => {
                        if (e.key === 'Backspace') {
                           const newCode = [...code];
                           newCode[index] = '';
                           setCode(newCode);

                           if (index > 0 && !code[index]) {
                              updateFocus(index, 'prev');
                           }
                        }
                     }}
                     onFocus={() => {
                        setFocus((prevFocus) => {
                           const newFocus = Array(6).fill(false);
                           newFocus[index] = true;
                           return newFocus;
                        });
                     }}
                  />
               ))}
            </div>
            {!hideText && (
               <div className="flex flex-col gap items-center">
                  <span className="small gray">
                     An email was sent to: <span className="white">{email}</span>
                  </span>
                  <Button
                     className="underline"
                     small
                     title="Resend Email"
                     type="transparent"
                     onClick={onResend}
                  />
               </div>
            )}
         </div>

         <div className="flex flex-col gap-3 items-center">
            <Button
               loading={isLoading}
               disabled={code.some((char) => !char)}
               title="Verify And Continue"
               type="white-big"
            />
            <Button
               className=""
               type="transparent-big"
               title="Cancel"
               onClick={onCancel}
            />
         </div>
      </form>
   );
}
